import { useEffect } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import { initMeteorAnimation } from './meteorAnimation';
import "../../css/meteorAnimation.css";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Layout({ children, showAdminNavigation = false }) {
    useEffect(() => {
        // Initialize the meteor animation in the container with id "meteor-animation"
        const animation = initMeteorAnimation();
        return () => {
            if (animation && typeof animation.stop === "function") {
                animation.stop();
            }
        };
    }, []);

    return (
        <div className="root-container">
            <div className="frontend-language">
                <LanguageSwitcher/>
            </div>
            {showAdminNavigation && <Navigation/>}
            {/* Meteor Animation Container */}
            <div id="meteor-animation" className="meteor-background"></div>
            <main className="main-container user-layout">
                <div className="main-sub-container">
                    {children}
                </div>
                <Footer/>
            </main>
        </div>
    );
}
